// extracted by mini-css-extract-plugin
export default {"h1":"styles_h1__VKrTD"};